import { render, staticRenderFns } from "./RelatorioIssuesTab.vue?vue&type=template&id=28f3abb9"
import script from "./RelatorioIssuesTab.vue?vue&type=script&lang=js"
export * from "./RelatorioIssuesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports